import { render, staticRenderFns } from "./MultiSelect2Ajax.vue?vue&type=template&id=56acda05"
import script from "./MultiSelect2Ajax.vue?vue&type=script&lang=ts"
export * from "./MultiSelect2Ajax.vue?vue&type=script&lang=ts"
import style0 from "./MultiSelect2Ajax.vue?vue&type=style&index=0&id=56acda05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports